import type { Ref } from 'vue';

export type Element = Record<
  'height' | 'offset' | 'distanceFromTop',
  Ref<null | number>
>;

export const isScrollWithinElementRange = ({ height, distanceFromTop }: Element) => {
  if (!height?.value || !distanceFromTop?.value) return false;

  const { scrollTop: scrollOffset } = document.documentElement;

  const { $headerOffset } = useNuxtApp();

  return (
    scrollOffset >= (distanceFromTop.value - ($headerOffset.value || 0)) &&
    scrollOffset <= (distanceFromTop.value - ($headerOffset.value || 0)) + height.value
  );
};

export const watchForIntersection = (element: Element): Ref<boolean> => {
  const isIntersected = ref(false);

  const scrollHandler = () => {
    isIntersected.value = isScrollWithinElementRange(element);
  };

  onMounted(() => {
    window.addEventListener('scroll', scrollHandler, { passive: true });
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', scrollHandler);
  });

  return isIntersected;
};
